// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/low-level-navigation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/low-level-navigation/low-level-navigation.js';

mount([g0]);
